import { render } from "./DeleteMinusWords.vue?vue&type=template&id=a6d5ab5a"
import script from "./DeleteMinusWords.vue?vue&type=script&lang=js"
export * from "./DeleteMinusWords.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__